export default __webpack_public_path__ + "static/media/5829425e44659ffcbf100d6c5e345142.c32de777.png";